import { jsx as _jsx } from "react/jsx-runtime";
import { orderHasInProgressAction } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { ItemPickerContextInstance } from '../types/context';
import { ItemPickerItemButton } from './item-button';
const b = bemClassBuilder('v-item-picker-grid');
export const ItemPickerGrid = observer(({ itemButtons }) => {
    const { config } = useContext(ItemPickerContextInstance);
    const isDisabled = !config.readonly && orderHasInProgressAction();
    return (_jsx("ul", Object.assign({ className: b.block({ disabled: isDisabled }) }, { children: itemButtons.map((itemButton, index) => (_jsx(ItemPickerItemButton, { itemProfileButton: itemButton }, `${itemButton.itemId}-${index}`))) })));
});
ItemPickerGrid.displayName = 'ItemPickerGrid';
